<template>
  <v-container fluid class="tenant-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/tenant/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="isFindTenant=true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_tenants.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="tenants-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="data_tenants_sorted"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteTenant"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Tenant?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_tenant.tenantname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteTenant = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_tenant)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.tenantimage="{ item }">
                  <img v-if="item.tenantimage" v-bind:src="item.tenantimage" alt="" width="80">
              </template>
              <template v-slot:item.tenantname="{ item }">
                <p class="two-line">{{ item.tenanttype  }}</p>
                <p class="two-line">{{ item.tenantname  }}</p>
              </template>
              <template v-slot:item.tenantaddress="{ item }">
                <a class="primaryConst--text">{{ item.tenantaddress }}</a>
                <p class="two-line">{{ item.tenantphone  }}</p>
                <p class="two-line">{{ item.tenantmobile  }}</p>
              </template>
              <template v-slot:item.propertyid="{ item }">
                <p class="two-line">{{ item.propertyid!=undefined && properties.find(i=>i._id == item.propertyid)!=null ? properties.find(i=>i._id == item.propertyid)['propertyname'] : ''   }}</p>
                <p class="two-line">{{ item.unitnum  }}</p>
              </template>
              <template v-slot:item.tenantstatus="{ item }">
                <v-chip
                  :color="item.tenantstatus=='Active' ? 'successConst white--text' : item.claimstatus=='New' ? 'primaryConst white--text' : item.claimstatus=='Inactive' ? 'greyTint white--text' : 'primaryConst white--text'"
                  small>
                  {{ item.tenantstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                <p class="two-line">{{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</p>

              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindTenant"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Tenants</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    :items="properties.filter(x=>x.propertystatus=='Active').map(x => {
                              return {text: x.propertyname, value: x._id};
                            })"
                    v-model="find_query.propertyid"
                    label="Property"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindTenant = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetSalesOrders"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findTenants"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TenantList',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'tenantimage', sortable: false, width: "8%" },
        { text: 'Name', value: 'tenantname'},
        { text: 'Address', value: 'tenantaddress', width: "25%"},
        { text: 'Property', value: 'propertyid', width: "25%" },
        { text: 'Status', value: 'tenantstatus', width: "10%"},
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,

      
      profile: {},
      showViewProfile: false,

      data_tenants: [],
      isDeleteTenant: false,
      delete_tenant: {},
      isFindTenant: false,
      find_query: {},
      menu_startdate: null,
      menu_enddate: null,   
    }
  },
  computed: {
    ...mapState('Tenant', ['tenants', 'isReceiving', 'isDeleting', 'idToDelete', 'tenantsMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('Property', ['properties']),
    ...mapState('User', ['users']),
    data_tenants_sorted(){
      let tenants = this.tenants.filter(tenant=>tenant.tenanttype=='Tenant');
      let others = this.tenants.filter(tenant=>tenant.tenanttype=='Other Tenant');
      return [...tenants, ...others];
    },
  },

  methods: {
    ...mapActions('Tenant', ["getTenantsRequest", "findTenantsQueryRequest", "deleteTenantRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Property', ["getPropertiesRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    async deleteItem(item) {
      this.isDeleteTenant = false;
      await this.deleteTenantRequest({_id: item._id});
      this.data_tenants = this.tenants;
    },
    deleteDialog(item) {
      this.isDeleteTenant = true;
      this.delete_tenant = {_id: item._id,tenantname: item.tenantname};
    },
    editItem(item) {
      this.$router.push({ name: 'TenantEdit', params: item })
    },
    async findTenants(){
      this.isFindTenant = false;
      if( Object.keys(this.find_query).length==0){
        await this.getTenantsRequest();
        this.data_tenants = this.tenants;
      }
      else{
        let result = await this.findTenantsQueryRequest(this.find_query);
        this.data_tenants = result;
      }
    },
    getJson(){
      let json = this.data_tenants.map(tenant=>{return {
        tenantname: tenant.tenantname, 
        type: tenant.tenanttype,
        address: tenant.tenantaddress,
        phone: tenant.tenantphone,
        mobile: tenant.tenantmobile,
        // region: tenant.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == tenant.regionid)['regionname'] : '',
        // township: tenant.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == tenant.townshipid)['townshipname'] : '',
        // salesrep: tenant.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == tenant.userid)['username'] : '',
        // createddate: tenant.createdAt!=undefined ? new Date(tenant.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        // lastorder: tenant.lastOrderDate!=undefined ? new Date(tenant.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        // ordercount: tenant.orders.length>0 ? tenant.orders.length : '',
        // map: 'http://maps.google.com/maps?q=' + tenant.geolocation.replace(' ', ''),
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'tenants-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    getBrands(list){
      let results = list.map(obj=> this.brands.find(brand=>brand._id==obj).brandname);
      return results.join(", ");
    },
    getItems(lists){
      let results = lists.map(obj=> this.items.find(item=>item._id==obj).itemname);
      return results.join(", ");
    },
    getCategories(lists){
      let results = lists.map(obj=> this.itemcategories.find(category=>category._id==obj)!=null ? this.itemcategories.find(category=>category._id==obj).itemcategoryname : '');
      return results.join(", ");
    },
    getGroups(lists){
      let results = lists.map(obj=> this.itemgroups.find(group=>group._id==obj)!=null ? this.itemgroups.find(group=>group._id==obj).itemgroupname : '');
      return results.join(", ");
    },
    async resetSalesOrders(){
      this.find_query = {};
    },
    viewItem(item) {
      this.$router.push({ name: 'TenantView', params: item })
    },
  },
  async created () {
    if(this.tenants.length==0) await this.getTenantsRequest();
    this.data_tenants = this.tenants;
    if(this.properties.length==0) await this.getPropertiesRequest();

    //if(this.brands.length==0) await this.getBrandsRequest();
    //if(this.items.length==0) await this.getItemsRequest();
    //if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    //if(this.itemgroups.length==0) await this.getItemGroupsRequest();
    //if(this.locations.length==0) await this.getLocationsRequest();
    //if(this.regions.length==0) await this.getRegionsRequest();
    //if(this.townships.length==0) await this.getTownshipsRequest();
    //if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
